// extracted by mini-css-extract-plugin
export default {"template-list-loader":"AddFromSavedTemplateModal_template-list-loader__lxLC9","template-radio-list":"AddFromSavedTemplateModal_template-radio-list__vO1jw"};